import { render } from "./AtributosImovelComponent.vue?vue&type=template&id=909e2392&scoped=true"
import script from "./AtributosImovelComponent.vue?vue&type=script&lang=js"
export * from "./AtributosImovelComponent.vue?vue&type=script&lang=js"

import "./AtributosImovelComponent.vue?vue&type=style&index=0&id=909e2392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909e2392"]])

export default __exports__